import { Link, useLocation } from "@tanstack/react-router";

export function Footer() {
  const location = useLocation();

  // Detect current language from path
  const getLanguage = () => {
    const segments = location.pathname.split("/").filter(Boolean);
    const langs = ["uz", "ru", "en"];
    return langs.includes(segments[0]) ? segments[0] : "oz";
  };

  // Get internal page path preserving language
  const getPagePath = (page: string) => {
    const lang = getLanguage();
    return lang === "oz" ? `/${page}` : `/${lang}/${page}`;
  };

  // Get language home path
  const getLanguageHome = (lang: string) => {
    if (lang === "oz" || lang === "default") {
      return "/";
    }
    return `/${lang}`;
  };

  // Multi-language content
  const content = {
    "uz-Latn": {
      about: "Loyiha haqida",
      contact: "Aloqa",
      and: "va",
      project: "loyihasi",
    },
    "uz-Cyrl": {
      about: "Лойиҳа ҳақида",
      contact: "Алоқа",
      and: "ва",
      project: "лойиҳаси",
    },
    ru: {
      about: "О проекте",
      contact: "Контакты",
      and: "и",
      project: "проект",
    },
    "en-US": {
      about: "About",
      contact: "Contact",
      and: "and",
      project: "project",
    },
  };

  // Map language codes to content keys
  const langMap: Record<string, keyof typeof content> = {
    oz: "uz-Latn",
    uz: "uz-Cyrl",
    ru: "ru",
    en: "en-US",
  };

  const currentLang = getLanguage();
  const currentContent = content[langMap[currentLang]] || content["uz-Latn"];

  return (
    <footer className="flex flex-col gap-4">
      {/* Navigation and Social Links */}
      <div className="flex flex-wrap  gap-3 text-center font-medium text-sm">
        <Link to={getPagePath("about")} className="">
          {currentContent.about}
        </Link>
        <a
          href="https://contact.obuna.com/"
          target="_blank"
          rel="noopener noreferrer"
          className=""
        >
          {currentContent.contact}
        </a>
        <a
          href="https://old.lotin.uz"
          target="_blank"
          rel="noopener noreferrer"
          className=""
        >
          Old.Lotin.uz
        </a>
        <a
          href="https://www.facebook.com/lotinuz"
          target="_blank"
          rel="noopener noreferrer"
          className=""
        >
          Facebook
        </a>
        <a
          href="https://www.instagram.com/lotinuz/"
          target="_blank"
          rel="noopener noreferrer"
          className=""
        >
          Instagram
        </a>
        <a
          href="https://t.me/lotin_kirill"
          target="_blank"
          rel="noopener noreferrer"
          className=""
        >
          Telegram
        </a>
        <a
          href="https://twitter.com/lotinuz"
          target="_blank"
          rel="noopener noreferrer"
          className=""
        >
          Twitter
        </a>
      </div>

      {/* Language Selector */}
      <div className="flex flex-wrap gap-3 font-medium text-sm">
        <Link to={getLanguageHome("oz")} className="">
          O'zbekcha
        </Link>
        <Link to={getLanguageHome("uz")} className="">
          Ўзбекча
        </Link>
        <Link to={getLanguageHome("ru")} className="">
          Русский
        </Link>
        <Link to={getLanguageHome("en")} className="">
          English
        </Link>
      </div>

      {/* Copyright */}
      <div className=" text-gray-500 text-sm">© Lotin.uz, 2019—2026</div>

      {/* Company Attribution */}
      <div className=" text-gray-500 text-sm">
        <a
          href="https://obuna.com"
          target="_blank"
          rel="noopener noreferrer"
          className=""
        >
          Obuna
        </a>{" "}
        {currentContent.and}{" "}
        <a
          href="https://goodgroup.uz/"
          target="_blank"
          rel="noopener noreferrer"
          className=""
        >
          GoodGroup
        </a>{" "}
        {currentContent.project}.
      </div>

      {/* 18+ Badge */}
      <div>
        <a
          href="https://tvinfo.uz/?utm_source=plus18_lotin"
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-lg bg-red-500 px-2 py-1 text-white hover:bg-red-600 text-sm"
        >
          18+
        </a>
      </div>
    </footer>
  );
}
